function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import { FormattedMessage } from 'react-intl';
import { highlightedHourlyRecordsShape, highlightedRecordsShape } from 'shapes/bins';
import App from 'modules/App';
import BloodGlucoseProfileChart from 'components/Charts/BloodGlucoseProfileChart';
import BloodGlucoseProfileTimeChart from 'components/Charts/BloodGlucoseProfileTimeChart';
import * as selectors from '../../selectors';
import * as constants from '../../constants';
import messages from '../../messages';
import DaysSelector from '../../partials/DaysSelector';
import styles from './ProfileChart.pcss';
var _React_PureComponent;
class ProfileChart extends (_React_PureComponent = React.PureComponent) {
    renderUnit(conversion) {
        return /*#__PURE__*/ _jsx("p", {
            className: styles.unit,
            children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread_props(_object_spread({}, messages.labels.unit), {
                values: {
                    unit: conversion.unitSymbol
                }
            }))
        });
    }
    renderMainChart() {
        const { conversion, standards, highlightedHourlyRecords, direction, mode, highlightedRecords, isDisplayedAgpProfileChart } = this.props;
        switch(mode){
            case 'ALL':
                return /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        this.renderUnit(conversion),
                        /*#__PURE__*/ _jsx(BloodGlucoseProfileTimeChart, {
                            conversion: conversion,
                            standards: standards,
                            records: highlightedRecords,
                            direction: direction
                        })
                    ]
                });
            default:
                return isDisplayedAgpProfileChart ? /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        this.renderUnit(conversion),
                        /*#__PURE__*/ _jsx(BloodGlucoseProfileChart, {
                            conversion: conversion,
                            standards: standards,
                            highlightedHourlyRecords: highlightedHourlyRecords,
                            direction: direction
                        })
                    ]
                }) : /*#__PURE__*/ _jsxs("div", {
                    className: styles.insufficiencyInfo,
                    children: [
                        /*#__PURE__*/ _jsx("img", {
                            className: "blob",
                            src: "/assets/svg/placeholder-blob.svg",
                            alt: ""
                        }),
                        /*#__PURE__*/ _jsx("p", {
                            className: "text",
                            children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.labels.insufficiencyInfo))
                        })
                    ]
                });
        }
    }
    render() {
        const { conversion, standards, direction } = this.props;
        return /*#__PURE__*/ _jsxs("div", {
            className: "chartContainer",
            children: [
                this.renderMainChart(),
                /*#__PURE__*/ _jsx("h2", {
                    className: styles.subsection,
                    children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.headers.measurementsTable))
                }),
                /*#__PURE__*/ _jsx(DaysSelector, {
                    conversion: conversion,
                    standards: standards,
                    direction: direction,
                    onDatesChange: this.props.onDatesChange
                })
            ]
        });
    }
}
_define_property(ProfileChart, "propTypes", {
    // Implicit props
    highlightedHourlyRecords: highlightedHourlyRecordsShape,
    highlightedRecords: highlightedRecordsShape,
    isDisplayedAgpProfileChart: PropTypes.bool,
    // Explicit props
    conversion: PropTypes.object.isRequired,
    standards: PropTypes.shape({
        maxValue: PropTypes.number.isRequired,
        preMeal: PropTypes.shape({
            highThreshold: PropTypes.number.isRequired,
            lowThreshold: PropTypes.number.isRequired
        }),
        postMeal: PropTypes.shape({
            highThreshold: PropTypes.number.isRequired,
            lowThreshold: PropTypes.number.isRequired
        })
    }),
    direction: PropTypes.string,
    mode: PropTypes.oneOf(constants.MODES),
    start: PropTypes.number,
    end: PropTypes.number,
    // Explicit actions
    onDatesChange: PropTypes.func
});
const mapStateToProps = (state)=>({
        highlightedHourlyRecords: selectors.highlightedHourlyRecords(state),
        highlightedRecords: selectors.highlightedRecords(state),
        isDisplayedAgpProfileChart: selectors.isDisplayedAgpProfileChart(state),
        direction: App.selectors.direction(state)
    });
const ConnectedProfileChart = connect(mapStateToProps)(ProfileChart);
export default withStyles(styles)(ConnectedProfileChart);
